var _desc, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirthdayCake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeWidth: 3,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Birthday Cake") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M6 59.998V29.996a2 2 0 0 1 2-2h48a2 2 0 0 1 2 2v30.002",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M2 59.995h59.998",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M5.998 34.998a7.001 7.001 0 0 0 7 7c3.867 0 7-2.133 7-6m.002 0c0 3.867 3.135 6 7 6 3.867 0 7-2.133 7-6m0 0c0 3.867 3.135 6 7 6 3.867 0 7-2.133 7-6m0 0c0 3.867 3.135 6 7 6a6.974 6.974 0 0 0 3.002-.676M31.998 17.998v9.998m-16.002-9.998v9.998M48 17.998v9.998",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M18.996 8.998a7.341 7.341 0 0 0-3-5.998s-3 2.679-3 5.998a2.993 2.993 0 0 0 5.86.867 2.594 2.594 0 0 0 .14-.867zm16.002 0a7.341 7.341 0 0 0-3-5.998s-3 2.679-3 5.998a2.993 2.993 0 0 0 5.86.867 2.597 2.597 0 0 0 .14-.867zm16.002 0A7.341 7.341 0 0 0 48 3s-3 2.679-3 5.998a2.993 2.993 0 0 0 5.86.867 2.594 2.594 0 0 0 .14-.867z",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayCake);
export default __webpack_public_path__ + "static/media/birthday-cake.cc1b11fb.svg";
export { ForwardRef as ReactComponent };